export default __webpack_public_path__ + "static/media/phone-icon.98945fb5.svg";